import React, { useState } from 'react'
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { httpsCallable } from 'firebase/functions';
import { MdOutlineShoppingCart } from 'react-icons/md'
import { functions } from '../../../../../Infrastructure/config';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { Box, capitalize, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme } from '@mui/material'
   import { coursesHistorySx } from './styles';

export const CoursesHistory = ({ paymentHistory }) => {
  const theme = useTheme();
  const ip = useSelector((state) => state.ip.address)
  const page = useSelector((state)=> state.route.currentRoute)
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [modalErrorMessage, setModalErrorMessage] = useState("");
 
  const handleVisitReceipt = async (chargeKey) => {
    const popup = window.open('', '_blank');
    if (!popup) {
      setModalErrorMessage("Pop-ups are blocked in your browser. Please enable pop-ups to view the receipt.");
      setOpenErrorModal(true);
      return;
    }
    try {
      const getReceiptUrl = httpsCallable(functions, "downloadclassreceipt");
      const { data } = await getReceiptUrl({ chargeKey, ip, page });
      if (data?.isSuccess) {
        popup.location = data?.url;
      } else {
        popup.close();
        setModalErrorMessage("Class receipt isn't available");
        setOpenErrorModal(true);
      }
    } catch (error) {
      popup.close();
      setModalErrorMessage("An unexpected error occurred. Please try again later.");
      setOpenErrorModal(true);
    }
  }
const formatPaymentMethod = (method) => {
  if (!method) return '';
  const methodStr = Array.isArray(method) ? method[0] : method;
  return methodStr
    .replace(/_/g, ' ')
    .split(' ')
    .map(capitalize)
    .join(' ');
};
  return (
    <>
    <Dialog
      open={openErrorModal}
      onClose={() => setOpenErrorModal(false)}
      PaperProps={{
        sx: {
          width: '400px',
          maxWidth: '90%',
          borderRadius: 3,
          p: 2,
          backgroundColor: '#fff',
        },
      }}
    >
      <DialogTitle sx={coursesHistorySx.dialogTitle}>
        Error
      </DialogTitle>
      <DialogContent>
        <Box sx={coursesHistorySx.dialogContentBox}>
          <Typography color="text.secondary">
            {modalErrorMessage}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={coursesHistorySx.dialogActions}>
        <Button
          onClick={() => setOpenErrorModal(false)}
          variant="contained"
          sx={coursesHistorySx.closeButton}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
      {paymentHistory && paymentHistory?.length > 0 ? (
        <Box>
          <TableContainer component={Paper}>
            <Table sx={coursesHistorySx.table} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell sx={coursesHistorySx.tableHeadCellCourse}>Course Title</TableCell>
                  <TableCell sx={coursesHistorySx.tableHeadCell}>Class</TableCell>
                  <TableCell sx={coursesHistorySx.tableHeadCell}>Time</TableCell>
                  <TableCell sx={coursesHistorySx.tableHeadCell}>Date</TableCell>
                  <TableCell sx={coursesHistorySx.tableHeadCellPrice}>Total Price</TableCell>
                  <TableCell sx={coursesHistorySx.tableHeadCellPayment}>Payment Type</TableCell>
                  <TableCell sx={coursesHistorySx.tableHeadCell}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentHistory?.map((history, index) => {
                return(
                  <TableRow key={index}>
                    <TableCell
                      sx={coursesHistorySx.tableRowCell}
                      align="left"
                    >
                      <Box sx={coursesHistorySx.courseBox}>
                      <Box sx={coursesHistorySx.iconBox}>
                        <MdOutlineShoppingCart size={22} />
                      </Box>
                      <Tooltip title={history?.metadata?.course_title} placement="top" enterTouchDelay={0}>
                      <Typography
                        sx={{...coursesHistorySx.courseTitle, color: theme.palette.primary.main }}
                        color={'secondary'}
                        onClick={() => handleVisitReceipt(history.latest_charge)}
                      >
                        {history?.metadata?.course_title}
                      </Typography>
                      </Tooltip>
                    </Box>
                    </TableCell>
                    <TableCell sx={coursesHistorySx.tableRowCell} align="left">{history?.metadata?.cohort_id}</TableCell>
                    <TableCell sx={coursesHistorySx.tableRowCellTimeDate} align="left">
                       {dayjs.unix(history?.created).format('hh:mm A')}
                    </TableCell>
                    <TableCell sx={coursesHistorySx.tableRowCellTimeDate} align="left">
                       {dayjs.unix(history?.created).format('MM/DD/YYYY')}
                    </TableCell>
                    <TableCell sx={coursesHistorySx.tableRowCell} align="left">${(history?.amount / 100).toFixed(2)}</TableCell>
                    <TableCell sx={coursesHistorySx.tableRowCell} align="left">{formatPaymentMethod(history?.payment_method_types)}</TableCell>
                    <TableCell sx={coursesHistorySx.tableHeadCell}></TableCell>
                  </TableRow>
                )})}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <Typography variant="body1">No Courses</Typography>
      )}
    </>
  )
}
